import React, { useState, useEffect } from 'react';
import { apiService } from '../../services/api';

export default function OrderReceiverRevenue() {
  const [data, setData] = useState({ orders: [], totalRevenue: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setError('');
      try {
        const res = await apiService.orders.getSalesOrdersRevenue();
        if (!cancelled && res.data) {
          setData({
            orders: res.data.orders || [],
            totalRevenue: res.data.totalRevenue ?? 0,
          });
        }
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.error || err.message || 'Failed to load revenue');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  const formatDateTime = (d) => {
    if (!d) return '—';
    const date = new Date(d);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const hoursStr = String(hours).padStart(2, '0');
    return `${hoursStr}:${minutes} ${ampm}`;
  };

  return (
    <div className="p-3 sm:p-4 md:p-6">
      <div className="bg-white rounded-lg shadow-md border-l-4 border-green-500 p-3 sm:p-4 md:p-6">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-700 mb-2 sm:mb-4">Revenue</h1>
        <p className="text-gray-600 text-sm mb-4 sm:mb-6">Revenue from sales orders where payment has been received. Today only.</p>

        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}
        {loading && <div className="py-8 text-center text-gray-500">Loading…</div>}
        {!loading && (
          <>
            <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
              <div className="text-sm text-gray-600">Total revenue</div>
              <div className="text-xl sm:text-2xl font-bold text-green-800 tabular-nums">SAR {Number(data.totalRevenue).toFixed(2)}</div>
            </div>
            {data.orders.length === 0 ? (
              <p className="text-gray-500 py-4">No orders with payment received yet.</p>
            ) : (
              <div className="space-y-3">
                {data.orders.map((o) => (
                  <div
                    key={o._id}
                    className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 py-3 px-3 sm:py-2 sm:px-3 bg-gray-50 rounded-lg border border-gray-100"
                  >
                    <div className="min-w-0">
                      <span className="font-medium text-gray-800">{o.orderNo}</span>
                      <span className="text-gray-500 text-sm ml-0 sm:ml-2 block sm:inline">{formatDateTime(o.dateTime)}</span>
                      {o.customerName && (
                        <span className="text-gray-500 text-sm ml-0 sm:ml-2 block sm:inline">· {o.customerName}</span>
                      )}
                    </div>
                    <span className="font-semibold text-gray-800 tabular-nums flex-shrink-0">SAR {Number(o.totalAmount || 0).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
